<div class="p-6">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    <h3 class="font-bold font-sans">{{ '::Orders' | abpLocalization }}</h3>
    <div class="flex flex-col md:flex-row gap-2 md:ml-auto">
      <app-metro-button
        variant="secondary"
        text=""
        [icon]="excelIcon"
        [iconSize]="'18'"
        [iconColor]="'#1C2D36'"
        [loading]="isExporting"
        (clicked)="generateExcel()">
      </app-metro-button>
      <app-metro-button
        variant="secondary"
        text="{{ '::NewOrder' | abpLocalization }}"
        (clicked)="openCreate()">
      </app-metro-button>
    </div>
  </div>

  <div class="flex flex-col mt-3">
    <app-metro-search-input (search)="onSearch($event)" (cleared)="onClearSearch()"></app-metro-search-input>
  </div>

  <!-- Delivery Confirmation Modal -->
  <app-metro-modal [isOpen]="showDeliveryConfirmModal" [title]="'::ConfirmDelivery' | abpLocalization"
    (close)="showDeliveryConfirmModal = false" [showCloseIcon]="true" (confirm)="onConfirmDelivery()"
    [confirmText]="'::Deliver' | abpLocalization">
    <p class="text-gray-700 font-sans">{{ '::ConfirmDeliveryMessage' | abpLocalization }}</p>
  </app-metro-modal>

  <!-- Escritorio: tabla. winepassport#389 — en mobile la tabla empujaba la columna de acciones
       fuera de pantalla; ahí se usan las tarjetas de abajo. -->
  <div class="hidden md:flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
    @if (isLoading) {
      <app-metro-table-skeleton [columns]="columns"></app-metro-table-skeleton>
    } @else {
      <app-metro-table [columns]="columns" [data]="data.items" [actions]="actions" [pageSize]="10"
        [currentPage]="list.page + 1" (pageChange)="onPageChange($event)" [isServerPaginated]="true"
      [totalItems]="data.totalCount">
      </app-metro-table>
    }
  </div>

  <!-- Mobile: tarjetas con "Confirmar Pago" a la vista (mismo patrón que Cupones). pb-24 para
       que la barra de navegación mobile no tape la última tarjeta. -->
  <div class="md:hidden mt-3 pb-24">
    @if (isLoading) {
      <div class="space-y-3">
        @for (i of [1, 2, 3]; track i) {
          <div class="h-36 bg-gray-100 rounded-2xl animate-pulse"></div>
        }
      </div>
    } @else if (!data.items.length) {
      <p class="text-sm text-gray-500 text-center py-8">{{ '::NoOrdersFound' | abpLocalization }}</p>
    } @else {
      <div class="space-y-3">
        @for (order of data.items; track order.id) {
          <div class="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm font-sans">
            <div class="px-4 py-4">
              <div class="flex items-center justify-between gap-2 mb-3">
                <p class="text-base font-bold text-gray-900">#{{ order.id }}</p>
                <span class="px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-metro-secondary text-metro-black">
                  {{ ('::' + order.orderStatus) | abpLocalization }}
                </span>
              </div>
              <div class="grid grid-cols-2 gap-x-3 gap-y-2">
                <div class="min-w-0">
                  <p class="text-[11px] text-gray-400">{{ '::Date' | abpLocalization }}</p>
                  <p class="text-sm text-gray-800">{{ order.creationTime }}</p>
                </div>
                <div class="min-w-0">
                  <p class="text-[11px] text-gray-400">{{ '::Total' | abpLocalization }}</p>
                  <p class="text-sm font-semibold text-gray-900">{{ order.total }}</p>
                </div>
                <div class="min-w-0 col-span-2">
                  <p class="text-[11px] text-gray-400">{{ '::Sommelier' | abpLocalization }}</p>
                  <p class="text-sm text-gray-800 truncate">{{ order.sommelierName || '-' }}</p>
                </div>
              </div>
            </div>

            <div class="border-t border-gray-100 flex">
              <button type="button" (click)="viewOrder(order)"
                class="flex-1 min-h-[44px] text-sm font-medium text-gray-700 active:bg-gray-50">
                {{ '::View' | abpLocalization }}
              </button>
              @if (order.canConfirmPayment) {
                <button type="button" (click)="showConfirmPaymentModal(order)" [disabled]="confirmingOrderIds.has(order.id)"
                  class="flex-1 min-h-[44px] text-sm font-semibold text-white bg-metro-blue-secondary active:opacity-80 disabled:opacity-50">
                  {{ '::ConfirmPayment' | abpLocalization }}
                </button>
              }
            </div>
          </div>
        }
      </div>

      @if (totalPages > 1) {
        <div class="mt-4 flex items-center justify-between">
          <button type="button" (click)="onPageChange(list.page)" [disabled]="list.page === 0"
            class="min-h-[44px] px-4 text-sm font-medium text-gray-700 disabled:opacity-30">‹ {{ 'AbpUi::PagerPrevious' | abpLocalization }}</button>
          <span class="text-sm text-gray-500">{{ list.page + 1 }} / {{ totalPages }}</span>
          <button type="button" (click)="onPageChange(list.page + 2)" [disabled]="list.page + 1 >= totalPages"
            class="min-h-[44px] px-4 text-sm font-medium text-gray-700 disabled:opacity-30">{{ 'AbpUi::PagerNext' | abpLocalization }} ›</button>
        </div>
      }
    }
  </div>
</div>